// extracted by mini-css-extract-plugin
export default {"logoGouv":"Login_logoGouv__tS5te","logoLink":"Login_logoLink__CK-Jq","logoWrapper":"Login_logoWrapper__44--g","feedbackButton":"Login_feedbackButton__ai+js"};